<template>
    <div>
        <div class="ecran bloc col-lg-12">
            <h5>Modalités</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Installation de matériel: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.demenagement_installation_materiel"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Monte meuble: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.demenagement_monte_meuble"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Nacelle - Grue: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.demenagement_nacelle_grue"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Autre: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.demenagement_autre"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Précision: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.demenagement_autre_precision"></b-input></b-col>
                </b-row>
            </div>
        </div>

        <div class="ecran bloc col-lg-12">
            <h5>Stationnement</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Stationnement d'un véhicule: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-checkbox :disabled="isDisabled" value="1" unchecked-value="0" v-model="request.demenagement_stationnement"></b-checkbox></b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Immatriculation: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6"><b-input :disabled="isDisabled" v-model="request.demenagement_immatriculation"></b-input></b-col>
                </b-row>
            </div>
        </div>

        <div class="ecran bloc col-lg-12">
            <h5>Dates</h5>
            <div class="content-bloc">
                <b-row>
                    <b-col style="float: left;" cols="12" lg="6"><b>Date de début: </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6">
                        <b-form-datepicker hide-header :start-weekday="1" v-model="date_deb" :disabled="isDisabled && isHourDisabled" placeholder="Date de début" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                    </b-col>

                    <b-col style="float: left;" cols="12" lg="6"><b>Date de fin (incluse): </b></b-col>
                    <b-col style="float: left;" cols="12" lg="6">
                        <b-form-datepicker hide-header :start-weekday="1" v-model="date_fin" :disabled="isDisabled && isHourDisabled" placeholder="Date de fin" today-button today-button-variant="primary" label-help="" label-today-button="Aujourd'hui"></b-form-datepicker>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuex from "vuex";

    export default {
        name: "Demenagement",
        async mounted() {
            if(this.request.id == null && this.id != null)
                await this.getDemande({layername: 'odp_demenagement', id: this.id});
        },
        props: ["id"],
        computed: {
            request: {
                get() {
                    return this.currentDemande;
                },
                set(value) {
                    this.setDemande(value);
                }
            },
            date_deb: {
                get() {
                    if(this.request.date_deb.indexOf('/') > -1)
                        return this.formatDate(this.request, 'date_deb')
                    else
                        return this.request.date_deb;
                },
                set(value) {
                    this.request.date_deb = value;
                }
            },
            date_fin: {
                get() {
                    if(this.request.date_fin.indexOf('/') > -1)
                        return this.formatDate(this.request, 'date_fin')
                    else
                        return this.request.date_fin;
                },
                set(value) {
                    this.request.date_fin = value;
                }
            },
            ...Vuex.mapGetters('Demande', ['currentDemande']),
            ...Vuex.mapGetters('Application', ['isHourDisabled', 'isDisabled'])
        },
        methods: {
            formatDetails(value) {
                return !!parseInt(value);
            },
            formatDate(value, row) {
                if(typeof value === 'undefined')
                    return "";
                else {
                    let date;
                    if(row == 'date_deb')
                        date = value.date_deb.split('/');
                    else if (row == 'date_fin')
                        date = value.date_fin.split('/');

                    date = date[2] + '-' + date[1] + '-' + date[0];
                    // console.log(date);
                    return date;
                }
            },
            ...Vuex.mapActions('Demande', ['getDemande', "setDemande"])
        }
    }
</script>

<style scoped>

</style>